import Container from '@mui/material/Container';
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import {Typography }from '@mui/material';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const TokenomicsWrapper = styled(Container)`
    display: flex;
    align-items: center;
    background-image:url("./assets/Tokenomics bg.png");
    background-size:cover;
    background-repeat:no-repeat;
    padding: 20px 24px;
    @media (min-width: 767px){
        height:100vh;
    }
    @media (max-width: 600px){
        padding-top: 30px;
        padding-bottom: 30px;
    }
`
const TokenomicsHeading = styled(Typography)`
    font-size:45px;
    font-family:poppins;
    font-weight:900;
    color:#F3D332;
    @media(min-width: 1800px){
            font-size:130px;
        }
    @media (max-width: 1900px) and (min-width: 1300px){
            font-size:75px;
        }
`
const TokenImg = styled.img`
    width:80%;
    max-width:80%;
    height:auto;
    @media (max-width: 1300px) and (min-width: 750px){
            width:300px;
            max-width:300px;
            height:auto;
        }
    @media (max-width: 749px){
        width:200px;
        max-width:200px;
        height:auto;
    }
    @media (max-width: 1900px) and (min-width: 1300px){
        width:70%;
        max-width:70%;
        height:auto;
    }
    @media(min-width: 1901px){
        width:650px;
        max-width:650px;
        height:auto;
    }
`
const TokenomicsImgWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    align-items:center;
    @media (max-width: 1024px) and (min-width: 768px){
        justify-content:end;
    }
`

const ImgWrapper = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    @media (max-width:1800px) and (min-width: 1200px){
        justify-content:end;
    }
`
const TokenomicsContentWrapper = styled(Grid)`
    @media (max-width:749px){
        margin-bottom:10px;
    }
`
const YellowText = styled(Typography)`
    color:#F3D332;
    font-size:16px;
    font-weight:300;
    text-align:center;
    font-family:poppins;
    text-align:center;
    @media (max-width: 2000px) and (min-width: 1301px){
            font-size:18px;
        }
    @media (min-width: 1900px){
            font-size:35px;
        }
`
const TokenContent = styled.div`
    background: #000;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    justify-content: center;
    padding:25px;
    @media (max-width: 2000px) and (min-width: 1301px){
        padding:50px 25px;
    }
`
const BoldText = styled(Typography)`
    color:#fff;
    font-size:45px;
    font-family:poppins;
    font-weight:900;
    text-align:center;
    margin:5px 0px;
    @media (max-width: 749px){
        font-size:25px;
    }
    @media (max-width: 1300px) and (min-width: 750px){
        font-size:35px;
    }
    @media (max-width: 1900px) and (min-width: 1301px){
        font-size:45px;
    }
    @media (min-width: 1900px){
        font-size:80px;
    }
`
const ContractContent =styled.div`
    background:#F3D332;
    margin-top:15px;
    border-radius:10px;
    display:flex;
    justify-content:space-between;
    padding:10px;
    @media (min-width: 2000px){
        margin-top:20px;
    }
    @media(max-width: 749px){
        padding:7px;
    }
`
const ContractText = styled(Typography)`
    font-family:poppins;
    font-size:20px;
    font-weight:600;
    @media(min-width: 1900px){
        font-size:40px;
    }
`
const TokenInnerWrapper = styled(Grid)`
    @media (min-width: 900px){
        display:flex;
        justify-content:center;
    }
`
const TbaWrapper  = styled.div`
    display:flex;
    align-items:center;
`
const TbaImg  = styled.img`
    height:23px;
    width:18px;
    margin-left:10px;
    @media (min-width: 2000px){
        height:33px;
        width:28px;
        margin-left:20px;
    }
`

export default function Tokenomics() {
    useEffect(() => {
        AOS.init({duration: 1200,});
      }, [])
    return (
          <>
          <TokenomicsWrapper maxWidth="xxl" id="tokenomics">
            <TokenInnerWrapper container >
                <Grid item xs={12} sm={11} md={10} lg={10} xl={10} >
                    <TokenomicsHeading data-aos="fade-right" variant='h1'>
                        Tokenomics
                    </TokenomicsHeading>
                </Grid>
                <TokenomicsContentWrapper data-aos="fade-right" item xs={12} sm={6} md={5} lg={5} xl={5} >
                    <TokenContent>
                        <YellowText variant='p'>
                            Total Supply
                        </YellowText>
                        <BoldText variant='h1'>
                            000.000,000,000
                        </BoldText>
                        <YellowText variant='p'>
                            Symbol
                        </YellowText>
                        <BoldText variant='h1'>
                            $BPSYOP
                        </BoldText>
                        <YellowText variant='p'>
                             TAX
                        </YellowText>
                        <BoldText variant='h1'>
                            TBA
                        </BoldText>
                    </TokenContent>
                    <ContractContent>
                        <ContractText>Contract:</ContractText>
                        <TbaWrapper><ContractText>TBA</ContractText><TbaImg src="./assets/Icon ionic-ios-copy.png" /></TbaWrapper>
                    </ContractContent>
                </TokenomicsContentWrapper>
                <TokenomicsImgWrapper item xs={12} sm={6} md={5} lg={5} xl={5} >
                    <ImgWrapper>
                        <TokenImg data-aos="fade-left" src="./assets/Tokenomics Image.png" alt=""/>
                    </ImgWrapper>
                </TokenomicsImgWrapper>
            </TokenInnerWrapper>
          </TokenomicsWrapper>
          </>
    );
  }